@let form = block();
@let links = form.controls.links;
<div
  [formGroup]="form"
  class="grid grid-cols-1 gap-4 lg:grid-cols-[12rem_minmax(0,1fr)]">
  <div class="text-standard-text-secondary pt-3 pl-8 text-sm font-semibold">
    {{ cmsTextProvider.footer.links }}
  </div>
  <div class="flex min-w-0 flex-col gap-4">
    @for (link of links.controls; track link; let linkIndex = $index) {
      <div class="flex items-start gap-3">
        <div class="flex min-h-12 flex-col items-center justify-center">
          <button
            type="button"
            class="text-info-main flex h-6 cursor-pointer items-center disabled:cursor-default disabled:opacity-40"
            [disabled]="linkIndex === 0"
            [attr.aria-label]="
              'Link ' + (linkIndex + 1) + ' nach oben verschieben'
            "
            (click)="moveLink(linkIndex, -1)">
            <span class="material-symbols-rounded text-xl!" aria-hidden="true"
              >keyboard_arrow_up</span
            >
          </button>
          <button
            type="button"
            class="text-info-main flex h-6 cursor-pointer items-center disabled:cursor-default disabled:opacity-40"
            [disabled]="linkIndex === links.length - 1"
            [attr.aria-label]="
              'Link ' + (linkIndex + 1) + ' nach unten verschieben'
            "
            (click)="moveLink(linkIndex, 1)">
            <span class="material-symbols-rounded text-xl!" aria-hidden="true"
              >keyboard_arrow_down</span
            >
          </button>
        </div>
        <div class="grid min-w-0 flex-1 grid-cols-1 gap-3 md:grid-cols-2">
          <aw-translation-text-input
            [entityType]="EntityType.footerLinkArea"
            [relationType]="TextRelationType.text"
            [id]="'block-link-text-' + index() + '-' + linkIndex"
            [formControl]="link.controls.texts"
            [label]="cmsTextProvider.footer.description" />
          <aw-translation-text-input
            [entityType]="EntityType.footerLinkArea"
            [relationType]="TextRelationType.url"
            [id]="'block-link-url-' + index() + '-' + linkIndex"
            [formControl]="link.controls.urls"
            [label]="cmsTextProvider.footer.linkAddressLabel" />
        </div>
        <aw-button
          class="block w-12 shrink-0 [&>button]:h-12! [&>button]:w-12! [&>button]:p-0!"
          [id]="'delete-block-link-' + index() + '-' + linkIndex"
          type="button"
          [style]="'error-alt'"
          buttonSize="quadratic"
          (click)="removeLink(linkIndex)">
          <span class="material-symbols-rounded text-xl!" aria-hidden="true"
            >delete</span
          >
          <span class="sr-only">{{ cmsTextProvider.shared.delete }}</span>
        </aw-button>
      </div>
    }
    <aw-button
      class="blue w-fit [&>button]:text-sm [&>button]:text-[#0066CC]!"
      [id]="'add-block-link-' + index()"
      type="button"
      [style]="'primary-alt'"
      buttonSize="small"
      (click)="addLink()">
      <span class="material-symbols-rounded mr-1 text-base!" aria-hidden="true"
        >add</span
      >
      {{ cmsTextProvider.shared.add }}
    </aw-button>
  </div>
</div>
